/**
 * FBSBancaRIOBAMBA
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EfectivizarTransferenciaExternaMS { 
    numeroCuentaOrigen?: string | null;
    numeroCuentaDestino?: string | null;
    fecha?: string | null;
    beneficiario?: string | null;
    correo?: string | null;
    telefono?: string | null;
    documento?: string | null;
    institucion?: string | null;
    concepto?: string | null;
    monto?: number;
    otpValido?: boolean;
    bloqueo?: boolean;
    tipoCuentaDestino?: string | null;
    nombreTitular?: string | null;
    secuencialMovimiento?:any;
    secuencialTransferencia?:number;
}

